import React from "react"

type SearchIcon = {
  onClick?: Function
}
export const SearchIcon: React.FC<SearchIcon> = props => {
  return (
    <div className="filter-control-item" onClick={() => props.onClick()}>
      <i className="material-icons ripple search-icon" title={"検索"}>
        search
      </i>
    </div>
  )
}
